import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import AvnyFrameImg from "@workspace/main/src/assets/images/Avny Frame.png";
import {
  BASE_PRE_ASSESSMENT,
  BASE_DOCUMENTS,
} from "../../../helpers/url_helper";
import { JOB_URL, DOCUMENT_URL } from "@workspace/common/src/config";
import { CoLogos } from "@workspace/common";

const PreAssessmentPlayBackStream = ({
  height = "70vh",
  videoSrc,
  botTimestamps,
  width = "80%",
  isLoading,
  candidateId,
  jobId,
  selfAssessmentId = null,
}) => {
  // ========================== Setting ==========================
  const audioPlaybackRate = 1;
  // =============================================================
  const dispatch = useDispatch();
  const videoRef = useRef(null);
  const [isSeeking, setIsSeeking] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);
  const [videoTime, setVideoTime] = useState(0);
  const [videoDuration, setVideoDuration] = useState(0);
  const [videoVolume, setVideoVolume] = useState(1);

  const handleTimeUpdate = () => {
    if (isSeeking) return;
    const video = videoRef.current;
    if (video) {
      setVideoTime(video.currentTime);
    }
  };

  const handleSeekStart = () => {
    setIsSeeking(true);
  };

  const handleSeekEnd = () => {
    setIsSeeking(false);
    const video = videoRef.current;
  };

  const handlePause = () => {
    setVideoPlaying(false);
  };

  const handlePlay = () => {
    setVideoPlaying(true);
    const video = videoRef.current;
  };

  const handleRangeChange = (e) => {
    const video = videoRef.current;
    const newTime = e.target.value;
    setVideoTime(newTime);
    if (video) {
      video.currentTime = newTime;
    }
  };

  useEffect(() => {
    setVideoDuration(videoRef.current?.duration || 0);
  }, [videoRef.current?.duration]);

  const togglePlayPause = () => {
    const video = videoRef.current;
    if (video) {
      if (videoPlaying) {
        video.pause();
      } else {
        video.play();
      }
    }
    setVideoPlaying(!videoPlaying);
  };

  const handleVolumeChange = (e) => {
    const video = videoRef.current;
    const newVolume = e.target.value;
    setVideoVolume(newVolume);
    if (video) {
      video.volume = newVolume;
    }
  };

  const getVolumeIcon = () => {
    if (videoVolume === 0) {
      return "ri-volume-mute-line";
    } else if (videoVolume < 0.5) {
      return "ri-volume-down-line";
    } else {
      return "ri-volume-up-line";
    }
  };

  return (
    <div>
      {/* // Video and Chatbot */}
      <div className="d-flex flex-column align-items-center">
        <div
          className="flex-grow-1"
          style={{
            borderRadius: "10px",
            padding: "10px",
            border: "1px solid #BED8FF",
            backgroundColor: "#EEF3F8",
            position: "relative",
            // minWidth: width,
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "20px",
              left: "20px",
              width: "200px",
              height: "auto",
            }}
          >
            <CoLogos
              imgSrc={`
              ${DOCUMENT_URL}${BASE_DOCUMENTS}/image/job/${jobId}`}
            />
          </div>
          <img
            src={AvnyFrameImg}
            alt="Avny frame"
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              width: "200px",
              height: "auto",
            }}
          />
          <video
            ref={videoRef}
            src={
              selfAssessmentId
                ? `${JOB_URL}${BASE_PRE_ASSESSMENT}/stream?selfAssessmentId=${selfAssessmentId}`
                : `${JOB_URL}${BASE_PRE_ASSESSMENT}/stream?jobId=${jobId}&candidateId=${candidateId}`
            }
            controls
            onTimeUpdate={handleTimeUpdate}
            onPause={handlePause}
            onPlay={handlePlay}
            onSeeking={handleSeekStart}
            onSeeked={handleSeekEnd}
            style={{
              objectFit: "fill",
              height: "auto",
              borderRadius: "10px",
              border: "1px solid #CAD329",
            }}
          />
        </div>
      </div>

      {/* Video External Controls 1) Range, Play and pause and Volume */}
      <div
        className="d-flex flex-column justify-content-center mt-5"
        style={{
          width: "100%",
        }}
      >
        <div style={{ position: "relative", minWidth: "100%" }}>
          {/* Current Time on the Left */}
          <div
            style={{
              position: "absolute",
              top: "-20px",
              left: "0",
              fontSize: "14px",
              color: "#333",
            }}
          >
            {`${Math.floor(videoTime / 60)
              .toString()
              .padStart(2, "0")}:${Math.floor(videoTime % 60)
              .toString()
              .padStart(2, "0")}`}
          </div>

          {/* Max Duration on the Right */}
          <div
            style={{
              position: "absolute",
              top: "-20px",
              right: "0",
              fontSize: "14px",
              color: "#333",
            }}
          >
            {`${Math.floor(videoDuration / 60)
              .toString()
              .padStart(2, "0")}:${Math.floor(videoDuration % 60)
              .toString()
              .padStart(2, "0")}`}
          </div>

          {/* Range Input */}
          <input
            type="range"
            min="0"
            max={videoDuration}
            step="0.01"
            value={videoTime}
            onChange={handleRangeChange}
            style={{ width: "100%" }}
          />
        </div>
        <div className="d-flex align-items-center justify-content-between">
          <i className=" ri-settings-2-line" style={{ fontSize: "1.5rem" }} />
          <div className="d-flex align-items-center gap-2">
            <i
              className=" ri-arrow-go-back-line"
              style={{
                fontSize: "1.8rem",
              }}
            ></i>
            {/* <button onClick={togglePlayPause}> */}
            {videoPlaying ? (
              <i
                style={{
                  fontSize: "1.8rem",
                }}
                className="ri-pause-circle-line cursor-pointer"
                onClick={togglePlayPause}
              ></i>
            ) : (
              <i
                style={{
                  fontSize: "1.8rem",
                }}
                className="ri-play-circle-line cursor-pointer"
                onClick={togglePlayPause}
              ></i>
            )}
            {/* </button> */}
            <i
              className=" ri-arrow-go-forward-line"
              style={{
                fontSize: "1.8rem",
              }}
            ></i>
          </div>

          <div className="d-flex gap-2 align-items-center">
            <i
              className={getVolumeIcon()}
              style={{
                fontSize: "1.5rem",
                cursor: "pointer",
              }}
            ></i>
            <input
              type="range"
              min="0"
              max="1"
              step="0.1"
              value={videoVolume}
              onChange={handleVolumeChange}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreAssessmentPlayBackStream;
